import { computed } from 'vue'
import { useFetch } from '#imports'
import type { HblTrustedShopsRating } from '@/utils/types'

export function useTrustedShops () {
    const { data: rating } = useFetch<HblTrustedShopsRating | null>('/api/trustedshops/rating', {
        key: 'trustedshops-rating',
        default: () => null
    })

    /** German and French both use a decimal comma, so this holds for all three builds */
    const formattedRating = computed<string | null>(() => {
        const value = rating.value?.rating

        return typeof value === 'number' ? value.toFixed(2).replace('.', ',') : null
    })

    /** Trusted Shops' own grade buckets, translated by the consumer */
    const ratingLabelKey = computed<string | null>(() => {
        const value = rating.value?.rating

        if (typeof value !== 'number') {
            return null
        }

        if (value >= 4.5) {
            return 'excellent'
        }
        if (value >= 4) {
            return 'veryGood'
        }
        if (value >= 3.5) {
            return 'good'
        }
        if (value >= 3) {
            return 'satisfactory'
        }

        return 'sufficient'
    })

    return {
        rating,
        formattedRating,
        ratingLabelKey
    }
}
